import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const WestIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5 1 C 7.210938 1 9 2.792969 9 5 C 9 7.210938 7.210938 9 5 9 C 2.789062 9 1 7.210938 1 5 C 1 2.792969 2.789062 1 5 1 Z M 5 1" />
            <path
                d="M 2.664062 1.753906 C 3.261719 1.320312 3.96875 1.066406 4.707031 1.011719 C 5.441406 0.957031 6.179688 1.105469 6.835938 1.445312 C 7.492188 1.785156 8.039062 2.296875 8.421875 2.929688 C 8.804688 3.558594 9.003906 4.285156 9 5.023438 C 8.996094 5.761719 8.789062 6.484375 8.398438 7.109375 C 8.007812 7.738281 7.453125 8.242188 6.792969 8.574219 C 6.136719 8.90625 5.398438 9.046875 4.660156 8.984375 C 3.925781 8.921875 3.222656 8.660156 2.628906 8.222656 L 5 5 Z M 2.664062 1.753906"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const WestIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5 1 C 7.210938 1 9 2.792969 9 5 C 9 7.210938 7.210938 9 5 9 C 2.789062 9 1 7.210938 1 5 C 1 2.792969 2.789062 1 5 1 Z M 5 1" />
            <path
                d="M 2.664062 1.753906 C 3.261719 1.320312 3.96875 1.066406 4.707031 1.011719 C 5.441406 0.957031 6.179688 1.105469 6.835938 1.445312 C 7.492188 1.785156 8.039062 2.296875 8.421875 2.929688 C 8.804688 3.558594 9.003906 4.285156 9 5.023438 C 8.996094 5.761719 8.789062 6.484375 8.398438 7.109375 C 8.007812 7.738281 7.453125 8.242188 6.792969 8.574219 C 6.136719 8.90625 5.398438 9.046875 4.660156 8.984375 C 3.925781 8.921875 3.222656 8.660156 2.628906 8.222656 L 5 5 Z M 2.664062 1.753906"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
